/* eslint-disable @typescript-eslint/no-explicit-any */
import { PortableText as BasePortableText } from "@portabletext/react";
import Divider from "@/components/divider";
import BlockComment from "@/components/PortableText/BlockComment";
import Blockquote from "@/components/PortableText/Blockquote";
import ExternalLink from "@/components/PortableText/LinkExternal";
import InternalLink from "@/components/PortableText/LinkInternal";
import List from "@/components/PortableText/List";
import Table from "@/components/PortableText/Table";
import logger from "@/utils/logger";
import EmbeddedHtml from "./EmbeddedHtml";
import Odds from "./Odds";
import type {
  PortableTextComponents,
  PortableTextProps,
  MissingComponentHandler,
} from "@portabletext/react";
import styles from "./portableText.module.scss";

export const DYNAMIC_ODDS_KEY = "dynamicOdds";

const ptComponents: PortableTextComponents = {
  // Totally custom types outside the scope of Portable Text
  // ex: image, mapLocation, contactForm, code, latestNews, code, etc.
  types: {
    internalLink: InternalLink,
    embedded: EmbeddedHtml,
    break: () => (
      <div className={styles.lineBreak}>
        <Divider />
      </div>
    ),
    customTable: Table,
    [DYNAMIC_ODDS_KEY]: Odds,
  },

  // Common list types
  // ex: common list types, checkmarks, anything custom
  list: {
    number: ({ children, value }) => (
      <List type={value.listItem} level={value.level}>
        {children}
      </List>
    ),
    bullet: ({ children, value }) => (
      <List type={value.listItem} level={value.level}>
        {children}
      </List>
    ),
  },

  // Custom components for marks
  // ex: characterReference, speech, popovers, etc.
  marks: {
    link: ExternalLink,
  },

  // Custom components for block styles
  block: {
    blockquote: ({ children }) => <Blockquote>{children}</Blockquote>,
    blockComment: ({ children }) => <BlockComment>{children}</BlockComment>,
  },
};

const onMissingComponent: MissingComponentHandler = (
  message: any,
  options: any
) => {
  logger.warn(message, {
    type: options.type,
    nodeType: options.nodeType, // 'block' | 'mark' | 'blockStyle' | 'listStyle' | 'listItemStyle'
  });
};

const PortableText = ({ value }: PortableTextProps) => (
  <div className={styles.typography}>
    <BasePortableText
      value={value}
      components={ptComponents}
      onMissingComponent={onMissingComponent}
    />
  </div>
);

export default PortableText;
